import axios from "axios";

/*** API: User ****/

/**
 * Query database for current user's data
 *
 * @param {String} jwt
 * @param {String} userId
 * @returns {Promise<object>} - returns a promise containing the user's data.
 */
export const getCurrentUser = async (jwt) => {
    let user = [];

    try {
        const { data } = await axios.get(
            `${process.env.NEXT_PUBLIC_API_URL}/auth/current-user/`,
            {
                headers: {
                    Authorization: `JWT ${jwt}`,
                    "Content-Type": "application/json",
                },
            }
        );

        user = data;
    } catch (e) {
        console.log("caught error", e);
        user = {
            error: e.message,
        };
    }

    return user;
};

/**
 * Makes a password update (not reset) request
 *
 * @param {String} newPassword
 * @returns {Promise<object>} - returns a promise with result of request
 */
export const changeUserPassword = async (jwt, currentPassword, newPassword) => {
    let response = "";
    try {
        const { data } = await axios.post(
            `${process.env.NEXT_PUBLIC_API_URL}/auth/users/set_password/`,
            {
                current_password: currentPassword,
                new_password: newPassword,
            },
            {
                headers: {
                    Authorization: `JWT ${jwt}`,
                    "Content-Type": "application/json",
                },
            }
        );

        response = data;
    } catch (e) {
        console.log("caught error", e);
        response = {
            // get error message from field validation list
            error: e.response.data,
            status: e.response.status,
        };
    }

    return response;
};

/**
 * Initiates password reset flow.
 *
 * @param {String} email
 * @returns {Promise<object>} - returns a promise with result of request
 */
export const resetUserPassword = async (email) => {
    let response = "";
    try {
        const { data } = await axios.post(
            `${process.env.NEXT_PUBLIC_API_URL}/auth/users/reset_password/`,
            {
                email,
            }
        );

        response = data;
    } catch (e) {
        console.log("caught error", e);
        response = e.response.data;
    }

    return response;
};

/**
 * Makes a password update (not reset) request
 *
 * @param {String} uid unique identifier included in link sent to user email
 * @param {String} token unique token included in link sent to user email
 * @param {String} newPassword new password submitted by user
 * @param {String} newPasswordConfirm new password confirmation
 * @returns {Promise<object>} - returns a promise with result of request
 */
export const resetUserPasswordConfirm = async (
    uid,
    token,
    newPassword,
    newPasswordConfirm
) => {
    let response = "";
    try {
        const { data } = await axios.post(
            `${process.env.NEXT_PUBLIC_API_URL}/auth/users/reset_password_confirm/`,
            {
                uid,
                token,
                new_password: newPassword,
                re_new_password: newPasswordConfirm,
            }
        );

        response = data;
    } catch (e) {
        console.log("caught error", e.response.data);
        response = {
            error: e.response.data,
            status: e.response.status,
        };
    }

    return response;
};
